import React, { useEffect, useState } from "react";
import { ModifyFormRightPanel } from "../common-components/modify-form-right-panel";
import "./task-layout.scss";
import { TaskLayoutSection } from "./task-layout-section";
import {
  AddFieldToLayoutSectionUtil,
  FormNames,
  sectionList,
} from "./task-layout-util";
import { PulseLoader } from "react-spinners";
import { GetDynamicFieldsForAdminPage } from "../../../../../../services/api/task-form-api";
import PropTypes from "prop-types";

export const TaskLayout = ({
  taskTypeId,
  SetTaskLayoutForm,
  taskLayoutFromParent,
}) => {
  const taskTypeIdToInt = parseInt(taskTypeId);
  const [taskLayout, setTaskLayout] = useState({
    data: null,
    DynamicFormFieldIdsToBeDeleted: [],
    isLoading: true,
  });

  useEffect(() => {
    const GetTaskLayout = async () => {
      try {
        if (!taskLayoutFromParent) {
          let result = null;
          if (taskTypeIdToInt > 0) {
            result = await GetDynamicFieldsForAdminPage(taskTypeIdToInt);
          }
          setTaskLayout((prev) => ({
            ...prev,
            data: result?.data,
            isLoading: false,
          }));
        } else {
          setTaskLayout((prev) => ({
            ...prev,
            data: taskLayoutFromParent.data,
            DynamicFormFieldIdsToBeDeleted:
              taskLayoutFromParent.DynamicFormFieldIdsToBeDeleted,
            isLoading: false,
          }));
        }
      } catch (e) {
        console.log("Error [GetDynamicFieldsForAdminPage] => ", e);
      }
    };
    GetTaskLayout();
  }, []);

  useEffect(() => {
    SetTaskLayoutForm(taskLayout, "taskLayout");
  }, [taskLayout]);

  const AddFieldToSection = (formDisplayOrder, field, subFormName) => {
    const newTaskLayout = AddFieldToLayoutSectionUtil(
      taskLayout.data,
      subFormName,
      field
    );

    setTaskLayout((prev) => ({
      ...prev,
      data: newTaskLayout,
    }));
  };

  return (
    <div className="task-layout">
      <>
        <div className="task-layout-content">
          {taskLayout.isLoading ? (
            <div className="pulse-loader" data-testid="loading-spinner-main">
              <PulseLoader></PulseLoader>
            </div>
          ) : (
            <>
              <TaskLayoutSection
                section={
                  taskLayout.data
                    ? taskLayout?.data[Object.keys(FormNames)[0]]
                    : null
                }
                label={FormNames.TaskDetailsForm}
                taskLayout={taskLayout}
                setTaskLayout={setTaskLayout}
              ></TaskLayoutSection>
              <TaskLayoutSection
                section={
                  taskLayout.data
                    ? taskLayout?.data[Object.keys(FormNames)[1]]
                    : null
                }
                label={FormNames.TaskCommentsForm}
                taskLayout={taskLayout}
                setTaskLayout={setTaskLayout}
              ></TaskLayoutSection>
            </>
          )}
        </div>
        <div className="task-layout-right-panel">
          <ModifyFormRightPanel
            subForms={sectionList}
            AddFieldToSection={AddFieldToSection}
            showURLField={false} //remove this prop once URL field is supported in task layout
          />
        </div>
      </>
    </div>
  );
};

TaskLayout.propTypes = {
  taskTypeId: PropTypes.string.isRequired,
  SetTaskLayoutForm: PropTypes.func.isRequired,
  taskLayoutFromParent: PropTypes.object,
};
